/**
 * Local UI state for the action row. Spec §5.6.
 *
 * Duplicated from apps/web per spec §6.2. Keep in sync.
 *
 * Two independent signals:
 *   `loading`  — the id of the command currently dispatching (spinner +
 *                disables peer buttons). `null` when idle.
 *   `pending`  — the catalog entry whose confirm dialog is open. `null` when
 *                closed. Consumers call `requestConfirm(cmd)` to open and
 *                `clearConfirm()` to close.
 *
 * No persistence. Confirm dialogs are local React state — not global — so
 * they vanish when the drawer unmounts.
 */
import { useState } from 'react';
import type { MdmCommandDefinition, MdmCommandId } from '@staff-app/shared-types';

export interface MdmActionState {
  loading: MdmCommandId | null;
  setLoading: (id: MdmCommandId | null) => void;
  pending: MdmCommandDefinition | null;
  requestConfirm: (cmd: MdmCommandDefinition) => void;
  clearConfirm: () => void;
}

export function useMdmActionState(): MdmActionState {
  const [loading, setLoading] = useState<MdmCommandId | null>(null);
  const [pending, setPending] = useState<MdmCommandDefinition | null>(null);

  return {
    loading,
    setLoading,
    pending,
    requestConfirm: (cmd) => setPending(cmd),
    clearConfirm: () => setPending(null),
  };
}
